

export default function Member({ member }) {
  return (
    <div className="relative">
      <div className="flex justify-center overflow-hidden rounded-md">
        <img
          src={member.image}
          alt={member.title}
          className="!relative w-full aspect-[1/1] object-cover"
        />
      </div>
      <div className="translate-y-[-50%] w-full px-4">
        <div className="bg-white w-full py-4 px-6 text-center">
          <h2 className="main-color text-base font-medium">{member.name}</h2>
          <p className="text-sm mt-2">{member.title}</p>
        </div>
      </div>
    </div>
  );
}
